import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import React from 'react'
import ConceptualLabelForm, { FORM_FIELDS } from '../ConceptualLabelForm'
import { useUpdateConceptualLabelMutation } from '../../../../../store/apis/conceptual-label.api'
import useConceptualLabel from '../../../../../hooks/useConceptualLabel'
import { Skeleton } from 'antd'

const EditConceptualLabelForm = ({ onSuccess }) => {
    const { canEdit, conceptualLabel } = useConceptualLabel()
    const [updateConceptualLabel, updateConceptualLabelResult] = useUpdateConceptualLabelMutation()

    const onSubmit = async values => {
        const response = await updateConceptualLabel({
            id: conceptualLabel.id,
            name: values.name,
            description: values.description,
            disciplineId: values.disciplineId,
            source: values.source,
            parentId: values.parentId,
            typeId: values.typeId,
        })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Conceptual label saved successfully')
            onSuccess()
        }
    }

    // Determine readonly fields based on access control
    const readonlyFields = canEdit 
        ? [FORM_FIELDS.DISCIPLINE, FORM_FIELDS.PARENT]  // Normal readonly fields for editable CLs
        : [FORM_FIELDS.NAME, FORM_FIELDS.DESCRIPTION, FORM_FIELDS.DISCIPLINE, FORM_FIELDS.SOURCE, FORM_FIELDS.PARENT, FORM_FIELDS.TYPE]  // All fields readonly for system CLs

    return !conceptualLabel ? (
        <Skeleton active />
    ) : (
        <ConceptualLabelForm
            onSubmit={onSubmit}
            error={updateConceptualLabelResult?.error}
            loading={updateConceptualLabelResult?.isLoading}
            submitButtonText='Save'
            initialValues={conceptualLabel}
            readonlyFields={readonlyFields}
        />
    )
}

export default EditConceptualLabelForm
